import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";

export class EditDeleteDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    handleOpenEdit = () => {
        console.log("open edit");
        console.log(this.props)
        this.props.agGridReact.props.getEditDetails(this.props.data)
    };

    handleOpenDelete = () => {
        console.log("open delete modal confirmation");
        console.log(this.props)
    };

    render() {
        return (
            <>
                <Button
                    onClick={this.handleOpenEdit}
                    //disabled={this.props?.data?.status == 'In Progress' || this.props?.data?.status == 'Completed' ? true : false}
                    basic
                    size="mini"
                    type="button"
                    icon
                >
                    {" "}
                    <Icon name="pencil alternate" color="green" />
                </Button>
                {/* <Button
                    onClick={this.handleOpenDelete}
                    basic
                    size="mini"
                    type="button"
                    icon
                >
                    {" "}
                    <Icon name="trash" color="red" />
                </Button> */}
            </>
        );
    }
}

export default EditDeleteDetails;
